import { OneTimePurchaseBookingStatus, SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';

export type AssetOwnershipStatus = SubscriptionBookingStatus | OneTimePurchaseBookingStatus;
